import { ACCOUNT_KIND } from "@theailab-dev/parchment";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DetailPageLayout } from "../../components/Layout/DetailPageLayout";
import { Badge } from "../../components/ui/Badge";
import { Button } from "../../components/ui/Button";
import { Card } from "../../components/ui/Card";
import { InfoItem } from "../../components/ui/InfoItem";
import { ROUTES } from "../../constants/routes";
import { useAuthStore } from "../../store/authStore";

/**
 * Profile 컴포넌트 - 관리자 프로필 페이지
 */
const Profile: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  /**
   * 비밀번호 변경 페이지로 이동
   */
  const handleChangePassword = () => {
    navigate(ROUTES.DASHBOARD_CHANGE_PASSWORD);
  };

  if (!user) {
    return (
      <DetailPageLayout
        title="내 프로필"
        subtitle="관리자 계정 정보를 확인합니다."
        isError={true}
        errorMessage="사용자 정보를 찾을 수 없습니다."
      >
        <div />
      </DetailPageLayout>
    );
  }

  return (
    <DetailPageLayout
      title="내 프로필"
      subtitle="관리자 계정 정보를 확인합니다."
      actions={null}
    >
      <div className="space-y-6">
        {/* 계정 정보 */}
        <Card title="계정 정보">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <InfoItem label="ID" value={user.id} />
            <InfoItem
              label="계정 종류"
              value={
                <Badge
                  variant={
                    user.kind === ACCOUNT_KIND.SYSTEM
                      ? "danger"
                      : user.kind === ACCOUNT_KIND.ADMIN
                        ? "primary"
                        : "neutral"
                  }
                >
                  {user.kind}
                </Badge>
              }
            />
            <InfoItem label="이메일" value={user.email} />
            <InfoItem label="이름" value={user.name || "-"} />
          </div>
        </Card>

        {/* 보안 설정 */}
        <Card title="보안 설정">
          <div className="space-y-4">
            <InfoItem
              label="비밀번호"
              value={
                <div className="flex items-center gap-3">
                  <span className="text-slate-500">••••••••</span>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={handleChangePassword}
                  >
                    변경
                  </Button>
                </div>
              }
            />
          </div>
        </Card>
      </div>
    </DetailPageLayout>
  );
};

export default Profile;
